// extracted by mini-css-extract-plugin
export var centerText = "_dp-8";
export var container = "_dp-0";
export var doughnutContainer = "_dp-7";
export var legend = "_dp-a";
export var legendItemColorDisplay = "_dp-b";
export var legendItemLabel = "_dp-d";
export var legendItemValue = "_dp-c";
export var lg = "_dp-5";
export var maxWidth = "_dp-9";
export var md = "_dp-4";
export var responsive = "_dp-6";
export var sm = "_dp-3";
export var xs = "_dp-2";
export var xxs = "_dp-1";